export default __webpack_public_path__ + "static/media/wallet-m.fcd35331.webp";